import React from 'react'
import styles from './Business.module.css';
import { Link } from "react-router-dom";
import Client from '../../images/MainPage/Client.svg';
import Partner from '../../images/MainPage/Partner.svg';
import Team from '../../images/MainPage/Team.svg';
import Categories from '../../images/MainPage/Categories.svg';
import Products from '../../images/MainPage/Products.svg';
import Preset from '../../images/MainPage/Preset.svg';
import Testimonials from '../../images/MainPage/Testimonials.svg';



function Business() {
    return (
        <div className={styles.cardscontainer}>
            <Link to="products">
                <div className={styles.cards}>
                    <img src={Products} alt="Admin"></img>
                    <h2>Products</h2>
                </div>
            </Link>
            <Link to="category">
                <div className={styles.cards}>
                    <img src={Categories} alt="Admin"></img>
                    <h2>Categories</h2>
                </div>
            </Link>
            <Link to="category">
                <div className={styles.cards}>
                    <img src={Preset} alt="Admin"></img>
                    <h2>Preset Packs</h2>
                </div>
            </Link>
            <Link to="/product-listing">
                <div className={styles.cards}>
                    <img src={Testimonials} alt="Admin"></img>
                    <h2>Products Export</h2>
                </div>
            </Link>
            <Link to="catalogs">
                <div className={styles.cards}>
                    <img src={Products} alt="catalogs"></img>
                    <h2>Catalogs</h2>
                </div>
            </Link>
            <Link to="groups">
                <div className={styles.cards}>
                    <img src={Partner} alt="groups"></img>
                    <h2>Groups</h2>
                </div>
            </Link>
            <Link to="users">
                <div className={styles.cards}>
                    <img src={Preset} alt="users"></img>
                    <h2>Users</h2>
                </div>
            </Link>
            <Link to="carts">
                <div className={styles.cards}>
                    <img src={Client} alt="Admin"></img>
                    <h2>Active Carts</h2>
                </div>
            </Link>
            <Link to="orders">
                <div className={styles.cards}>
                    <img src={Partner} alt="orders"></img>
                    <h2>Orders</h2>
                </div>
            </Link>
            <Link to="generate-kit">
                <div className={styles.cards}>
                    <img src={Categories} alt="generate-kit"></img>
                    <h2>Generate Kit</h2>
                </div>
            </Link>
          
        </div>
    )
}

export default Business